class UserDetailsController {
  constructor($mdToast, Plan, User, ChangePassword, PhoneValidation) {
    this.Plan = Plan;
    this.$mdToast = $mdToast;
    this.User = User;
    this.ChangePassword = ChangePassword;
    this.PhoneValidation = PhoneValidation;
  }
  $onInit() {
    const { User, Plan } = this;
    User.getHistory(this.user).then((history) => {
      this.history = history;
    });
    Plan.getPlans().then((plans) => {
      this.plans = plans;
    });
  }
  setEditMode(editMode = true) {
    this.isEditMode = editMode;
  }
  async assignPlan(plan, days = 30) {
    const { $mdToast } = this;
    const history = await this.User.assignPlan({ plan, user: this.user, days });
    this.history.unshift(history);
    $mdToast.show($mdToast.simple().textContent('Plan Asignado satisfactoriamente'));
  }
  async showChangePasswordDialog() {
    const { ChangePassword, user } = this;
    ChangePassword.showChangePasswordDialog(user);
  }
  showPhoneValidationDialog(phone) {
    const { PhoneValidation, user } = this;
    PhoneValidation.showPhoneValidationDialog(user, phone);
  }
  showPlanDialog() {
    const { Plan, user } = this;
    Plan.showAddPlanDialog(user)
      .then((history) => {
        if (history) {
          this.history.unshift(history);
        }
      })
      .catch((err) => {
        if (err) {
          console.error(err);
        }
        // canceled
      });
  }
  async updateUser(user) {
    const { User, $mdToast } = this;
    try {
      await User.update(user._id, user);
      this.setEditMode(false);
      $mdToast.show($mdToast.simple().textContent('Guardado exitosamente'));
    } catch (error) {
      $mdToast.show($mdToast.simple().textContent(`Ha abido un error intentando guardar ${error.message}`));
    }
  }
}
UserDetailsController.$inject = ['$mdToast', 'Plan', 'User', 'ChangePassword', 'PhoneValidation'];
export default UserDetailsController;



// WEBPACK FOOTER //
// ./client/app/components/user/userDetails/userDetails.controller.js